export const DEFAULT_PRECISION = 20;

export default {
  DEFAULT_PRECISION,
};
